import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import {useTranslation} from "react-i18next";
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {isalnum, isalpha} from './Util';
import {COMM_OK} from './WsR2.js';

function PwdDialog(props) {
	const { onClose, set_open, forced } = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const [password_1, setPasswd1] = useState('');
	const [password_2, setPasswd2] = useState('');

	const handleClose = () => {
    		onClose();
	}

	const passwd1Changed = (event) => {
		setPasswd1(event.target.value);
	}

	const validPwd = (pwd) => {
		let num, u_case, l_case, i;

		if (pwd.length < 1)
			return true;

		if (pwd.length < 6)
			return false;

		i = num = u_case = l_case = 0;

		while (i < pwd.length) {
			let ch = pwd.charAt(i);

			if (!isalnum(ch)) 
				return false;

			if (isalpha(ch)) {
				if (ch === ch.toUpperCase()) {
					u_case++;
				} else if (ch === ch.toLowerCase()) {
					l_case++;
				}
			} else {
				num++;
			}

			i++;
		}

		return num > 0 && u_case > 0 && l_case > 0 ? true : false;
	}

	const validPasswd1 = () => {
		return validPwd(password_1);
	}

	const passwd2Changed = (event) => {
		setPasswd2(event.target.value);
	}

	const validPasswd2 = () => {
		return validPwd(password_2);
	}

	const passwordsOkToSave = () => {
		if (password_1.length < 6 || password_2.length < 6)
			return false;

		return password_1 === password_2;
	}

	const pwdRxWs = (status, obj) => {
		if (status !== COMM_OK) {
			alert('Password change failed! Status' + status);
			return -1;
		}

		if (obj.cmd === 'user') {
			if (obj.op === 'password') {
				if (obj.result === 'OK') {
					if (forced) {
						gStorage.conn.setUser({...gStorage.conn.user, pwd_reset_req: 0})
					} else {
						alert(t('password.changed'));
					}

					onClose();
				} else {
					alert('Password change failed!');
				}
			} else {
				console.error('User: Rx: unknown user operation:', obj.op);
			}
		} else {
			console.error('User: Rx: unknown cmd', obj.cmd);
		}
	}

	const savePassword = () => {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'password',
			data: {
				user: {
					id: gStorage.conn.user.id,
					passwd: password_1
				}
			}
		};

		gStorage.conn.ws.send(msg, pwdRxWs);
	}

	const CloseButton = () => {
		if (forced) 
			return null;
		
		return (
			<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
				<CloseIcon />
			</IconButton>
		);
	}

	return (
        	<Dialog fullScreen onClose={handleClose} aria-labelledby="simple-dialog-title" open={set_open}>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>
							{t('menu.change_passwd')}
						</Typography>
						<CloseButton/>
					</Toolbar>
				</AppBar>

				<Grid size={{xs: 12}} align={'center'}>
					<Typography variant={'h6'}>
						{t('password.passwd_for')} &nbsp;{gStorage.conn.user.nick}
					</Typography>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('password.new_password')}
						variant="outlined"
						type="password"
						value={password_1}
						error={!validPasswd1()}
						onChange={passwd1Changed}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 20}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('password.retype_password')}
						variant="outlined"
						type="password"
						value={password_2}
						error={!validPasswd2()}
						onChange={passwd2Changed}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 20}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
				 	<Button 
				 		variant="contained" 
						color="primary" 
						size="small" 
						style={{width:143, margin: 8}} 
						disabled={!validPasswd2() || !validPasswd1() || !passwordsOkToSave()}
						onClick={savePassword}>
							{t('password.save')}
					</Button>
				</Grid>
			</Grid>
		</Dialog>
	);
}

export default PwdDialog;
